import React, { createContext, useReducer, useState, useEffect,useMemo } from 'react'
import { node } from 'prop-types'

const _initialState = {
  token: "",
  isLoggedIn: false,
  user: {
    name: "",
    surname: "",
  },
  companies: [],
  company: {},
  roles: [],
}

export const MainContext = createContext(_initialState);

export function MainStore(props) {
  console.log("MainStore:", props)
  const [state, setState] = useState(_initialState);
  const providerState = useMemo(() => ({ state, setState }), [state, setState])
  console.log("MainStore value:", state)
  return (
    <MainContext.Provider value={providerState}>
      {props.children}
    </MainContext.Provider>
  )
}

MainStore.defaultProps = {
  children: null
}

MainStore.propTypes = {
  children: node
}


